import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal }           from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }         from '@ngx-translate/core';

import { InvoiceModel }         from './models/invoice';
import { MessagesService }      from '../messages/messages.service';
import { Table }                from '../table/types/table';
import { TableColumn }          from '../table/types/table-column';
import { TableQueryParameters } from '../table/types/table-query-parameters';
import { TableService }         from '../table/table.service';

@Component({
  selector   : 'wor-invoices-for-payment',
  template: require('./invoices.for-payment.component.html')
})
export class InvoicesForPaymentComponent implements OnInit {
  @Input() cacheKey    : string;
  @Input() invoices    : Array<InvoiceModel> = [];
  @Input() isStoreShown = false;
  @Input() loadFn      : ( params : TableQueryParameters ) => Promise<Array<InvoiceModel>>;

  isAllSelected    = false;
  selectedInvoices : Array<InvoiceModel> = [];
  tableSettings    : Table;

  constructor (
    public  activeModal     : NgbActiveModal,
    private messagesService : MessagesService,
    private tableService    : TableService,
    private translateService: TranslateService
  ) {}

  ngOnInit () : void {
    const columns : Array<TableColumn> = [
      {
        classes: 'text-left',
        field  : 'invoice_number',
        header : {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.REFERENCE')
        }
      },
      {
        classes: 'text-left',
        field  : 'post_date',
        header : {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe: 'globalDate'
      },
      {
        classes: 'text-right',
        field  : 'total',
        header : {
          classes: 'text-right',
          text   : this.translateService.instant('JS_SPACE.COLUMNS.AMOUNT')
        },
        pipe: 'globalCurrency'
      },
      {
        classes: 'text-right',
        field  : 'balance_due',
        header : {
          classes: 'text-right',
          text   : this.translateService.instant('JS_SPACE.COLUMNS.BALANCE')
        },
        pipe: 'globalCurrency'
      }
    ];

    if ( this.isStoreShown ) {
      columns.splice(1, 0, {
        field : 'store_name',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.STORE')
        }
      });
    }

    this.tableSettings = {
      cache: {
        enabled: true,
        key    : this.cacheKey
      },
      columns,
      empty: {
        text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND')
      },
      pagination: {
        enabled: false
      },
      rows: {
        select: {
          enabled: true,
          multi  : true
        }
      },
      sorting: this.tableService.setSortingFromCache(this.cacheKey, {
        direction: 'desc',
        field    : 'post_date'
      }),
      static: true
    };
  }

  confirm () : void {
    if ( this.selectedInvoices.length ) {
      this.activeModal.close(this.selectedInvoices);
    }
  }

  get ( params : TableQueryParameters ) : void {
    this.loadFn(params)
      .then(( invoices : Array<InvoiceModel> ) => {
        this.invoices = invoices;

        this.handleInvoiceSelection();
      })
      .catch(error => this.messagesService.error(error));
  }

  handleInvoiceSelection () : void {
    this.selectedInvoices = this.invoices.filter(invoice => invoice.selected);

    this.isAllSelected = !!this.invoices.length && this.invoices.length === this.selectedInvoices.length;
  }

  toggleAll () : void {
    this.invoices.forEach(invoice => {
      invoice.selected = !this.isAllSelected;
    });

    this.handleInvoiceSelection();
  }
}
